export default {
  title: '品牌設置',
  basicInfo: '基本信息',
};
